import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

function XAuthCallback() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const dispatch = useDispatch();

	useEffect(() => {
		const code = searchParams.get('code');
		const state = searchParams.get('state');
		const error = searchParams.get('error');

		if (error || (!code && !state)) {
			navigate('/login', { replace: true });
			return;
		}

		dispatch({ type: 'X_AUTH_CALLBACK', payload: { code, state } });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
			<p>Completing X sign-in...</p>
		</div>
	);
}

export default XAuthCallback;
